import { inject, signal, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { ApiTypedTenantConfigurationService } from '@fullyops/data/tenant-configuration/typed-api-adapter';
import { UiAuthService } from '@fullyops/legacy/ui/ui-crm/ui-auth.service';
import { PermissionType } from '@fullyops/legacy/ui/ui-shared/utils/crm-types';

/**
 * Whether the current user may set an equipment's owner, which the back end only allows with
 * CAN_MANAGE_EQUIPMENT_OWNERSHIP while the tenant allows manual ownership changes. False until the
 * tenant configuration has loaded. Must be called in an injection context.
 */
export function injectCanAssignAssetOwner(): Signal<boolean> {
  const canManageOwnership = inject(UiAuthService).hasPermissionNoAsync([
    PermissionType.CAN_MANAGE_EQUIPMENT_OWNERSHIP,
  ]);
  if (!canManageOwnership) {
    return signal(false);
  }
  return toSignal(
    inject(ApiTypedTenantConfigurationService)
      .getAssetConfig()
      .pipe(map((cfg) => cfg.allowManualOwnershipChanges)),
    { initialValue: false },
  );
}
